const LinkedIn = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 31 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='15.4998' cy='15.5' r='14.2083' fill='#0A66C2' />
      <path
        d='M9.44931 11.34C10.5014 11.34 11.3542 10.4872 11.3542 9.43515C11.3542 8.38312 10.5014 7.53027 9.44931 7.53027C8.39728 7.53027 7.54443 8.38312 7.54443 9.43515C7.54443 10.4872 8.39728 11.34 9.44931 11.34Z'
        fill='white'
      />
      <path
        d='M13.0987 12.7478H16.2557V14.194C16.2557 14.194 17.1124 12.4806 19.4434 12.4806C21.5227 12.4806 23.2452 13.505 23.2452 16.6271V23.211H19.9736V17.4249C19.9736 15.5831 18.9903 15.3806 18.241 15.3806C16.686 15.3806 16.4198 16.7219 16.4198 17.6652V23.211H13.0987V12.7478Z'
        fill='white'
      />
      <path d='M7.78878 12.7478H11.1099V23.211H7.78878V12.7478Z' fill='white' />
    </svg>
  );
};

export default LinkedIn;
